<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">Create Termin Release</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Detail termin" />
      <a-step title="Document" />
    </a-steps>
    <div class="steps-content flex-1">
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button
          v-if="current < steps.length - 1"
          :disabled="mode == 'Edit' && disabledNext"
          type="primary"
          @click="next"
          >Next</a-button
        >
        <a-button
          :loading="loading"
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
          >{{ mode == "Edit" ? "Save Changes" : "Save" }}</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import Informasi from "./steps/Informasi.vue";
import DetailTermin from "./steps/DetailTermin.vue";
import Document from "./steps/Document.vue";

export default {
  name: "TerminReleaseCreate",
  props: ["id"],
  components: {
    Informasi,
    DetailTermin,
    Document,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "DetailTermin",
          content: "DetailTermin",
        },
        {
          title: "Document",
          content: "Document",
        },
      ],
      mode: "Create",
      collectData: {
        informasi : [],
        detilTermin : [],
        document: []
      },
      listPembelian: [],
      postData: new FormData(),
      postJson: {},
      editData: {},
      loading: false,
      projectAllsts: [],
      disabledNext: true,
    };
  },
  computed: {
    ...mapGetters(["getAuth","getDocumentTerminRelease"]),
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            collectData: this.collectData,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "DetailTermin") {
          return {
            collectData: this.collectData,
            mode: "Edit",
            id: this.id,
          };
        } else if (this.steps[this.current].content === "Document") {
          return {
            collectData: this.collectData,
            mode: "Edit",
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            listPembelian: this.collectData.detilTermin,
            collectData: this.collectData,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "DetailTermin") {
          return {
            collectData: this.collectData,
            mata_uang:"IDR",
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "Document") {
          return {
            collectData: this.collectData,
            mata_uang:"IDR",
            mode: this.mode,
          };
        }
      }
      return true;
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "DetailTermin") {
        return "refDetailTermin";
      } else if (this.steps[this.current].content === "Document") {
        return "refDocument";
      }
      return true;
    },
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.fetchDetail();
    }else{
      this.$store.dispatch("resetStateTerminRelease");
    }
  },
  methods: {
    ...mapActions(["FETCH_ALLOCATION", "FETCH_USEDFOR"]),
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "DetailTermin") {
        this.$refs.refDetailTermin.handleRef();
      } else if (this.steps[this.current].content === "Keuangan") {
        this.$refs.refKeuangan.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      this.$refs.refDocument.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = JSON.parse(
          JSON.stringify(value.informasi)
        );
        this.current++;
      } else if (this.steps[this.current].content === "DetailTermin") {
        // this.collectData.estimated_value = JSON.parse(
        //   JSON.stringify(value.estimated_value)
        // );
        // if (this.mode !== "Edit") {
        //   this.collectData.informasi.approval = JSON.parse(
        //     JSON.stringify(value.approval)
        //   );
        // }
        this.current++;
      } else if (this.steps[this.current].content === "Document") {
        this.collectData.document = value;

        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        } else {
          this.confirmMessage("confirm-save");
        }
      }
    },
    getUpdateTerminSalesContract(item) {
      if(item.action=="add"){
        this.collectData.detilTermin = [
          ...this.collectData.detilTermin,
          JSON.parse(JSON.stringify(item.values)),
        ];
      } else if(item.action=="remove") {
        let index = _.findIndex(this.collectData.detilTermin, (e) => { 
            return e.key == item.item.key; 
        }, 0); 
        const newFileList = this.collectData.detilTermin.slice();
        newFileList.splice(index, 1);
        this.collectData.detilTermin = newFileList;
      } else if(item.action=="edit") {
        let index = _.findIndex(this.collectData.detilTermin, (e) => { 
            return e.key === item.editdata.key
        }, 0); 
        this.collectData.detilTermin.splice(index, 1, item.values);
      }
    },
    submit() {
      let postData = new FormData();
      postData.append("tlc", this.getAuth.username);
      postData.append("date", moment(this.collectData.informasi.tgl_buat).format('YYYY-MM-DD'));
      postData.append("sales_contract", this.collectData.informasi.sales_contract);
      postData.append("note", this.collectData.informasi.note);
      postData.append("note", this.collectData.informasi.note);
      this.collectData.detilTermin.forEach((element,index) => {
        if(this.mode=="Edit"){
          postData.append(`detil[${index}][id]`, element.id);
        }
        postData.append(`detil[${index}][termin]`, element.termin);
        postData.append(`detil[${index}][value]`, element.value);
        postData.append(`detil[${index}][remark]`, element.remark);
      });
      this.collectData.document.forEach((data, index) => {
        postData.append(`description_document[${index}]`, data.description);
        postData.append(`select_document[${index}]`, data.document);
      });
      if(this.mode=="Edit"){
        postData.append("id_termin_release", this.id);
        this.getDocumentTerminRelease.forEach((data, index) => {
        postData.append(`document_old[${index}][id]`, data.id);
      });
      }

      this.loading = true;
      this.$store
      .dispatch("postTerminRelease", { mode: this.mode,
        payload: postData,
      })
      .then(() => {
        this.displayMessage("success-save");
        this.loading = false;
        this.$store.dispatch("resetStateTerminRelease");
        this.$router.push({ name: "terminRelease-List" });
      })
      .catch((err) => {
          let response = Object.assign({}, err.response.data);
          if (response.message) {
            this.displayMessageValue("error-other", response.message);
            this.loading = false;
          } else {
            console.log(response);
            this.displayMessageValue("error", response.message);
            this.loading = false;
          }
      });
    },
    async fetchDetail() {
      await this.$store
      .dispatch("fetchDataRevisiTerminRelease", { payload: this.id,})
      .then((data) => {
        let teminformation = [{
          ...data.information[0],
          tgl_buat: moment(data.information[0].create_dt),
          termin: data.information[0].id_termin_release,
          note :data.information[0].catatan
        },];
        this.collectData.informasi = teminformation[0];
        this.collectData.detilTermin = data.detail_termin;
        this.collectData.document = data.document;
      });
      
      // await axios({
      //   method: "get",
      //   url: this.$serviceUrl + "termin/detail",
      //   params: {
      //     id_termin_release: this.id,
      //     tlc: this.getAuth.username,
      //   },
      //   auth: {
      //     username: this.getAuth.username,
      //     password: this.getAuth.password,
      //   },
      //   headers: {
      //     "X-API-KEY": this.getAuth.apikey,
      //   },
      // })
      //   .then((response) => {
      //     let informasi = response.data.item_pp[1].informasi;
      //     //informasi.used_for = informasi.used_for.split(",");
      //     this.collectData = {
      //       infoUmum: response.data.item_pp[0],
      //       estimated_value: response.data.item_pp[0].estimated_value,
      //       informasi: informasi,
      //       keuangan: response.data.item_pp[2].keuangan,
      //       persetujuan: response.data.item_pp[3].persetujuan,
      //       listBeli: response.data.detil_pp,
      //       approval: response.data.approval_pp
      //     };

      //     response.data.detil_pp.forEach((item) => {
      //       this.collectData.detilTermin = [...this.collectData.detilTermin, { values: item }];
      //     });
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     this.displayMessage("error-aktif-project");
      //   });
      this.disabledNext = false;
    },
  },
  mounted() {
    this.FETCH_ALLOCATION();
    this.FETCH_USEDFOR();
    Event.$on("terminReleaseData", this.valueFromChild);
    Event.$on("updateListTerminSalesContract", this.getUpdateTerminSalesContract);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("terminReleaseData", this.valueFromChild);
    Event.$on("updateListTerminSalesContract", this.getUpdateTerminSalesContract);
    Event.$off("confirmMessageReturn", this.submit);
  },
};
</script>

<style></style>
